<template>
    <div class="">
        <div class="card-box t_center" :class="{'has-error': errors['logo']}" v-pml-block="isSaving">
            <label class="input_file">
                <input type="file" accept=".png, .jpg, .jpeg" @change="feedFile" class="hide">
                <img :src="company.logo_url || '/static/images/avatar-company.png'" alt="" class="img-responsive max_130">
                <span class="btn btn-white"><i class="fa fa-camera"></i> {{ $t('change') }}</span>
            </label>
            <span class="error" v-if="errors['logo']">{{ errors['logo'] }}</span>
            <h4 class="text-uppercase font-600 m-b-0">{{ company.fancy_name }}</h4>
        </div>
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { updateLogo } from 'services/company'
    import { mapGetters } from 'vuex'

    export default {
        name: 'Avatar',
        data () {
            return {
                isCancelling: false,
                isSaving: false,
                errors: []
            }
        },
        computed: {
            ...mapGetters({
                company: 'getCompany',
                tenant: 'getTenant'
            })
        },
        methods: {
            feedFile (e) {
                if (typeof e.target.files[0] === 'undefined') return

                this.isSaving = true

                let data = new window.FormData()
                data.append('logo', e.target.files[0])

                updateLogo(data)
                    .then(() => {
                        Notify.success(trans('_notifications.success'))
                        this.errors = []
                    })
                    .catch(error => { this.errors = error.response.data.errors || [] })
                    .then(() => { this.isSaving = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/company/components/Avatar.vue